import React, { useEffect, useState } from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { company, waLink } from '../mock';

export default function FloatingButtons() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Desktop floating WhatsApp */}
      <a
        href={waLink()}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        className={`hidden md:flex fixed z-40 bottom-6 left-6 items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-green-500/40 hover:scale-110 transition-transform ${show ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      >
        <MessageCircle className="w-7 h-7" />
      </a>

      {/* Mobile sticky call/whatsapp bar */}
      <div className="md:hidden fixed z-40 bottom-0 left-0 right-0 grid grid-cols-2 shadow-[0_-4px_20px_rgba(0,0,0,0.12)]">
        <a href={`tel:${company.phoneRaw}`} className="flex items-center justify-center gap-2 bg-primary text-white font-semibold h-14">
          <Phone className="w-5 h-5" /> Call Now
        </a>
        <a href={waLink()} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 bg-[#25D366] text-white font-semibold h-14">
          <MessageCircle className="w-5 h-5" /> WhatsApp
        </a>
      </div>
    </>
  );
}
